export default __webpack_public_path__ + "static/media/loader_bg.ec887d5c.png";